import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useCustomerInfo from "@repo/shopifyV2/hooks/useCustomerInfo";
import useCustomerInfoCaa from "@repo/shopifyV2/hooks/useCustomerInfoCaa";
import { extractId } from "@repo/shopifyV2/utils/common";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

import useCustomer from "@queries/useCustomer";
import useCustomerCaa from "@queries/useCustomerCaa";

import { useCustomerStore } from "@store/customer";

export default function useAddresses() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { customer, token, caaCustomer, updateCaa } = useCustomerStore();

  const { fetchCustomer } = useCustomer();
  const { fetchCaaCustomer } = useCustomerCaa();

  const { isPartnership, addresses } = useCustomerInfo(customer, "thisisneverthat");
  const { addresses: caaAddresses } = useCustomerInfoCaa(caaCustomer, "thisisneverthat");

  const isJp = lang === "jp";

  useEffect(() => {
    if (isJp) {
      if (!caaCustomer) navigate(URLS.HOME);
      return;
    }

    if (!customer || isPartnership) navigate(URLS.HOME);
  }, [isJp, customer, isPartnership, caaCustomer, navigate]);

  const onCompletedMutation = async () => {
    if (isJp) {
      const data = await fetchCaaCustomer();
      if (data?.customer) updateCaa(data.customer);
      return;
    }

    await fetchCustomer({ customerAccessToken: token.accessToken });
  };

  const defaultAddress = isJp ? caaCustomer?.defaultAddress : customer.defaultAddress;

  const otherAddresses = (isJp ? caaAddresses : addresses).filter((node) => extractId(node.id) !== extractId(String(defaultAddress?.id)));

  return {
    onCompletedMutation,
    defaultAddress,
    otherAddresses,
  };
}
